import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

const state = {
    performance_indicators: [],
    //TODO: Url no se encuentra en el Backend.
    performance_indicators_url: '/mesh/performance-indicator'
}

const getters = {
    [names.PERFORMANCE_INDICATORS]: state => {
        if (!get.store.state.user) return [];
        return state.performance_indicators.filter((x) => x.school == get.store.state.user.school);
    },
}

const mutations = {
    [names.MUTATE_PERFORMANCE_INDICATORS]: (state, performance_indicators) => {
        performance_indicators.forEach(element => {
            let index = state.performance_indicators.findIndex(x => x.id == element.id);
            if (index != -1) state.performance_indicators.splice(index, 1, element);
            else state.performance_indicators.push(element);
        });
    },
    [names.MUTATE_PERFORMANCE_INDICATOR]: (state, performance_indicator) => {
        let index = state.performance_indicators.findIndex(x => x.id == performance_indicator.id);
        if (index != -1) state.performance_indicators.splice(index, 1, performance_indicator);
        else state.performance_indicators.push(performance_indicator);
    },
    [names.MUTATE_DELETE_PERFORMANCE_INDICATOR]: (state, performance_indicator_id) => {
        let index = state.performance_indicators.findIndex(x => x.id == performance_indicator_id);
        if (index != -1) state.performance_indicators.splice(index, 1);
    },
}

const actions = {
    [names.FETCH_PERFORMANCE_INDICATOR]: ({
        commit,
        state
    }, performance_indicator_id) => {
        return new Promise((resolve) => {
            const indicator = state.performance_indicators.find(x => x.id == performance_indicator_id);
            if (indicator) {
                resolve(indicator);
                return;
            }
            restful.Get(`${state.performance_indicators_url}/${performance_indicator_id}/`)
                .then(response => {
                    commit(names.MUTATE_PERFORMANCE_INDICATOR, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_PERFORMANCE_INDICATORS]: ({
        commit,
        state,
    }, force) => {
        return new Promise((resolve) => {
            if (!force && state.performance_indicators.length > 0) {
                resolve(state.performance_indicators);
                return;
            }
            restful.Get(`${state.performance_indicators_url}/`)
                .then(response => {
                    commit(names.MUTATE_PERFORMANCE_INDICATORS, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_PERFORMANCE_INDICATORS_BY_CYCLE]: ({
        commit,
        state,
    }, cycle_id) => {
        return new Promise((resolve) => {
            restful.Get(`${state.performance_indicators_url}/?cycle=${cycle_id}`)
                .then(response => {
                    commit(names.MUTATE_PERFORMANCE_INDICATORS, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_PERFORMANCE_INDICATORS_BY_COMPETENCE]: ({
        commit,
        state,
    }, institution_competence_id) => {
        return new Promise((resolve) => {
            restful.Get(`${state.performance_indicators_url}/?institution_competence=${institution_competence_id}`)
                .then(response => {
                    commit(names.MUTATE_PERFORMANCE_INDICATORS, response);
                    resolve(response);
                });
        });
    },
    [names.POST_PERFORMANCE_INDICATOR]: ({
        commit,
        state
    }, performance_indicator) => {
        return new Promise((resolve) => {
            restful.Post(`${state.performance_indicators_url}/`, performance_indicator)
                .then(response => {
                    commit(names.MUTATE_PERFORMANCE_INDICATOR, response);
                    resolve(response);
                });
        });
    },
    [names.UPDATE_PERFORMANCE_INDICATOR]: ({
        commit,
        state
    }, performance_indicator) => {
        return new Promise((resolve) => {
            restful.Put(`${state.performance_indicators_url}/${performance_indicator.id}/`, performance_indicator)
                .then(response => {
                    commit(names.MUTATE_PERFORMANCE_INDICATOR, response);
                    resolve(response);
                });
        });
    },
    [names.PATCH_PERFORMANCE_INDICATOR]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Patch(`${state.performance_indicators_url}/${payload.performance_indicator_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_PERFORMANCE_INDICATOR, response);
                    resolve(response);
                });
        });
    },
    [names.DELETE_PERFORMANCE_INDICATOR]: ({
        commit,
        state
    }, performance_indicator_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.performance_indicators_url}/${performance_indicator_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_PERFORMANCE_INDICATOR, performance_indicator_id);
                    resolve(response);
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};